import { render } from "./facility-actions.vue?vue&type=template&id=2e4aa058&scoped=true"
import script from "./facility-actions.vue?vue&type=script&lang=js"
export * from "./facility-actions.vue?vue&type=script&lang=js"

import "./facility-actions.vue?vue&type=style&index=0&id=2e4aa058&lang=scss&scoped=true"

import exportComponent from "/home/node/ks-web/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2e4aa058"]])

export default __exports__